module.exports = __webpack_public_path__ + "static/media/sonda.e52de13e.png";